import { ChangeEvent, LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutCheckCallComplianceDetail } from "./autogen/AutogenLayoutCheckCallComplianceDetail";

export class CheckCallComplianceDetail extends AutogenLayoutCheckCallComplianceDetail {
    switchCountCarriercallsOntimeOnChange(event: ChangeEvent) {
        this.checkboxIncldBrokerinitiatedCalls.enabled = !event.newValue;
        this.checkboxIncldCarrInitiatedCalls.enabled = !event.newValue;
        if (event.newValue) {
            this.checkboxIncldBrokerinitiatedCalls.checked = true;
            this.checkboxIncldCarrInitiatedCalls.checked = true;
        }
    }

    textboxOrderTypesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = 'Y';
    }
}